import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";

import { ApolloClient } from 'apollo-client';
import { Query, Mutation } from "react-apollo";
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from "graphql-tag";
import { HttpLink } from 'apollo-link-http';
// import { Proof } from "../../components/Proof/Proof.jsx";

import VideoYouTube from "../../components/Youtube/Youtube.jsx";

import Slider from "react-slick";

// import YouTube from 'react-youtube';


const restLink = new HttpLink({
  uri: "/api/v1/lms/",
  credentials: 'include'
});
const lms_client = new ApolloClient({
  link: restLink,
  cache: new InMemoryCache(),
});

const restLink_dam = new HttpLink({
  uri: "/api/v1/dam/",
  credentials: 'include'
});
const dam_client = new ApolloClient({
  link: restLink_dam,
  cache: new InMemoryCache(),
});




const GET_CURSES = gql`{
  courses_collections{
    courses{
      id,title,thumbnail
    }
  }
}
`;


const USER_HAS_VIDEO = gql`
  mutation insert_user_has_video($video_id: String!){
    insert_user_has_video(video_id: $video_id){
      id
    }
  }
`;

const VIDEO_HAS_USER = gql`
  mutation createOrUpdateVideoHasUser($user_id: Int!, $video_id: String!, $time: Int!, $time_reproduced: Int!, $time_seconds: String!){
    createOrUpdateVideoHasUser( input:{user_id: $user_id, video_id:$video_id, time:$time, time_reproduced:$time_reproduced, time_seconds:$time_seconds}) {
      id
    }
  }
`;


const USER_HAS_VIDEO_FINISH = gql`
  mutation finish_user_has_video($video_id: String!){
    finish_user_has_video(video_id: $video_id) {
      id
    }
  }
`;

var player = false;
var jsonObj = [];


class Video extends Component {


  urlPlayer;
  videoOpen = false;
  curTime = 0;


  constructor() {
    super();
    this.state = {
      like: false,
      favorite: false
    };

  }


  setLike() {
    this.setState(state => ({
      ...state,
      like: !this.state.like
    }));
  }
  setFavorite() {
    this.setState(state => ({
      ...state,
      favorite: !this.state.favorite
    }));
  }



  componentDidMount() {

    var videoId = this.props.match.params.video_id;
    // setInterval(), 2000); 
  }


  _onReady = async (event) => {
    player = event.target;
    setInterval(this.getCurTime, 900); // pega 0.9 segundos, para evitar pular algun segundo por delay
  }

  getCurTime() {

    console.log('---------------------');


    if (player) {


      var time = parseInt(player.getCurrentTime());
      var timeAll = parseInt(player.getDuration());

      if (time > 0) {

        var item = {};
        item = time;
        jsonObj.push(item);
        var timesString = JSON.stringify(jsonObj);

        if (time > (this.curTime + 60)) {
          console.log("entrou no segundo " + time);
          this.curTime = time;
          lms_client.mutate({
            mutation: VIDEO_HAS_USER,
            variables: {
              user_id: 1, video_id: this.props.match.params.video_id, time: timeAll, time_reproduced: 0, time_seconds: timesString,
            }
          });
        }



      }
    }



  }



  render() {

    const windowWidth = window.innerWidth;

    var settings_courses = {
      autoplay: false,
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: (windowWidth <= 987 ? 2 : 4),
      slidesToScroll: (windowWidth <= 987 ? 2 : 4)
    };

    // Salva o Item como Concluído para o usuário, só por ter aberto o item
    if (this.props.match.params.video_id && !this.videoOpen) {
      this.videoOpen = true;
      lms_client.mutate({
        variables: { video_id: this.props.match.params.video_id },
        mutation: USER_HAS_VIDEO
      });
    }

    const opts = {
      height: '390',
      width: '640',
      playerVars: {
        // https://developers.google.com/youtube/player_parameters
        autoplay: 0,
      },
    };


    return (

      <div id="CoursePage">

        <div className="content">


          <Grid fluid>
            <Row>
              <Col md={1}></Col>
              <Col md={10}>
                <div>

                  <Query
                    client={lms_client}
                    variables={{ video_id: this.props.match.params.video_id }}
                    query={gql`
                  query getVideo($video_id: String!) {
                    video(video_id:$video_id){
                      id
                      name
                      description
                      duration
                      uuid
                    }
                  }
                  `}
                  >

                    {({ loading, error, data }) => {
                      if (loading) return <div>Carregando...</div>;
                      if (error) return <div>Erro :(</div>;

                      return (
                        <div>                         
                            <VideoYouTube
                              videoId={data.video.uuid}
                              opts={opts}
                            />

                          <h1>{data.video.name}</h1>
                          <p>{data.video.description}</p>
                        </div>
                      );
                    }}
                  </Query>


                </div>
              </Col>
              <Col md={1}></Col>

            </Row>

          </Grid>
        </div>


        <div className="content content_bar">
          <Grid fluid>
            <Row>
              <Col md={12}>
                <h2>
                  Mais assistidos
                  </h2>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Query
                  client={lms_client}
                  query={GET_CURSES}
                >
                  {({ loading, error, data }) => {
                    if (loading) return <div>Carregando...</div>;
                    if (error) return <div>Erro :(</div>;

                    return (
                      <Slider {...settings_courses}>
                        {data.courses_collections.courses.map((item) => (
                          <div key={item.id} className="course-item">
                            <a
                              data-gtm-type="click"
                              data-gtm-clicktype="card"
                              data-gtm-name={item.title}
                              href={"/#/curso/" + item.id}>
                              <img src={"/lms/assets/" + item.thumbnail} />
                              <div className="title">{item.title}</div>
                            </a>
                          </div>
                        ))}
                      </Slider>
                    )
                  }}
                </Query>
              </Col>
            </Row>
          </Grid>
        </div>

      </div>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/views/Videos/Video.jsx